import {
  ComponentBuilder,
  ComponentBuilderFetchDataInputs,
} from 'strapi/componentBuilder';
import { PageTypes } from 'strapi/page/types';

import { collectImageSectionComponentParams } from './collector';
import { ImageText } from './ImageText';
import { ImageSectionStrapiComponent, ImageTextProps } from './types';

export class ImageSectionComponentBuilder extends ComponentBuilder {
  public key = 'text-with-image.image-section' as const;

  async fetchData(inputs: ComponentBuilderFetchDataInputs) {
    const fieldName = this.getFieldNameSymbol(inputs.componentData);

    const page = await inputs.fetchManager.addRequestOptionsAndWaitForResponse<{
      fieldName: ImageSectionStrapiComponent;
    }>({
      populate: {
        [fieldName]: {
          populate: {
            button: true,
            sectionList: true,
            media: {
              populate: {
                media: true,
              },
            },
          },
        },
      },
    });

    const componentData = page[fieldName];
    if (!componentData) {
      return undefined;
    }

    const arrayComponentData = Array.isArray(componentData)
      ? componentData
      : [componentData];

    return arrayComponentData
      .map((componentData) =>
        collectImageSectionComponentParams(
          componentData,
          // We force the type to be PageTypes just to satisfy the type checker
          // and to be able to re-use the code of the collector in this context
          page as unknown as PageTypes
        )
      )
      .filter((x) => !!x) as ImageTextProps[];
  }

  render(inputs: Awaited<ReturnType<(typeof this)['fetchData']>>) {
    if (inputs && inputs.length > 0) {
      return (
        <>
          {inputs.map((input) => (
            <ImageText key={`imagesection_${input.title}`} {...input} />
          ))}
        </>
      );
    } else {
      return null;
    }
  }
}
